import { FlowrunnerContextFiles, type FlowrunnerContextFilesOptions } from './context-files'

export type FlowrunnerContextOptions = FlowrunnerContextFilesOptions

export class FlowrunnerContext {
  Files: FlowrunnerContextFiles

  constructor(options: FlowrunnerContextOptions) {
    this.Files = new FlowrunnerContextFiles(options)
  }
}
